import { CollectionType } from '../../data-layer/collections/service';
import { FlexProps } from '../../ui/layout/Flex';
import { CollectionCard } from '../../ui/users/CollectionCard';
import { CollectionsGrid } from '../../ui/users/CollectionsGrid';
import { UserCollectionsTabs as Tabs } from './UserCollectionsTabs';
import { useCollectionsController } from './useCollectionsController';
import { withCollectionCallbacks } from './withCollectionCallbacks';

const EnhancedCollectionCard = withCollectionCallbacks(CollectionCard);

interface UserCollectionsProps extends FlexProps {
    hasTabs: boolean;
    collectionType: CollectionType;
    columnsCount?: number;
    onChangeTab: (type: CollectionType) => void;
}

export function UserCollections({
    hasTabs,
    collectionType,
    columnsCount,
    onChangeTab,
    ...other
}: UserCollectionsProps) {
    const { savedCollections, createdCollections, isLoading } = useCollectionsController();

    const currentCollection =
        collectionType === CollectionType.SAVED ? savedCollections : createdCollections;

    return (
        <>
            {hasTabs ? <Tabs collectionType={collectionType} onChange={onChangeTab} /> : null}
            <CollectionsGrid
                {...other}
                collections={currentCollection}
                isLoading={isLoading}
                columnsCount={columnsCount}
                renderItem={(index) => (
                    <EnhancedCollectionCard
                        key={currentCollection[index].id}
                        collection={currentCollection[index]}
                        isSaved={currentCollection[index].isSaved}
                        isOwner={!currentCollection[index].isSaved}
                        columnsCount={columnsCount}
                    />
                )}
            />
        </>
    );
}
